import {batchActions} from 'redux-batched-actions';

import {CustomClient4} from '../client'
import {ChannelTypes, UserTypes} from 'mattermost-redux/action_types';
import {General} from 'mattermost-redux/constants';

import {logError} from 'mattermost-redux/actions/errors';
import {forceLogoutIfNecessary} from 'mattermost-redux/actions/helpers';
import ChannelStore from 'stores/channel_store.jsx';

export function updateSelfDestructTimer(channelId, patch) {
    return async (dispatch, getState) => {
        dispatch({type: ChannelTypes.UPDATE_CHANNEL_REQUEST}, getState);

        let updated;
        try {

            updated = await CustomClient4.updateSelfDestructTimer(channelId, patch);
        } catch (error) {
            forceLogoutIfNecessary(error, dispatch);

            dispatch(batchActions([
                {type: ChannelTypes.UPDATE_CHANNEL_FAILURE, error},
                logError(error)(dispatch)
            ]), getState);
            return null;
        }

        dispatch(batchActions([
            {
                type: ChannelTypes.RECEIVED_CHANNEL,
                data: updated
            },
            {
                type: ChannelTypes.UPDATE_CHANNEL_SUCCESS
            }
        ]), getState);

        return updated;
    };
}

export function batchUpdateSelfDestructTimer(selfDestructProps) {
    return async (dispatch, getState) => {
        dispatch({type: ChannelTypes.UPDATE_CHANNEL_REQUEST}, getState);

        try {

            await CustomClient4.batchUpdateSelfDestructTimer(selfDestructProps);
        } catch (error) {
            forceLogoutIfNecessary(error, dispatch);

            dispatch(batchActions([
                {type: ChannelTypes.UPDATE_CHANNEL_FAILURE, error},
                logError(error)(dispatch)
            ]), getState);
            return null;
        }

        dispatch({type: ChannelTypes.UPDATE_CHANNEL_SUCCESS}, getState);


        return true;
    };
}

export function initTalk2Site(channelId) {
    return async (dispatch, getState) => {
        dispatch({type: ChannelTypes.UPDATE_CHANNEL_REQUEST}, getState);

        let updated;
        try {
            updated = await CustomClient4.initTalk2Site(channelId);
        } catch (error) {
            forceLogoutIfNecessary(error, dispatch);

            dispatch(batchActions([
                {type: ChannelTypes.UPDATE_CHANNEL_FAILURE, error},
                logError(error)(dispatch)
            ]), getState);
            return null;
        }

        dispatch(batchActions([
            {
                type: ChannelTypes.RECEIVED_CHANNEL,
                data: updated
            },
            {
                type: ChannelTypes.UPDATE_CHANNEL_SUCCESS
            }
        ]), getState);

        return updated;
    };
}

export function getMyAllChannels() {
    return async (dispatch, getState) => {

        let channels;
        try {
            channels = await CustomClient4.getMyAllChannels();
        } catch (error) {
            forceLogoutIfNecessary(error, dispatch);
        }
        return channels;
    };
}

export function getMyAllMembers() {
    return async (dispatch, getState) => {

        let users;
        try {
            users = await CustomClient4.getMyAllMembers();
        } catch (error) {
            forceLogoutIfNecessary(error, dispatch);
        }
        return users;
    };
}

export function getMyAllTeamUsers() {
    return async (dispatch, getState) => {

        let users;
        try {
            users = await CustomClient4.getMyAllTeamUsers();
        } catch (error) {
            forceLogoutIfNecessary(error, dispatch);
        }
        return users;
    };
}


export function getChannelsByIds(channelIds) {
    return async (dispatch, getState) => {
        let channels;
        try {
            channels = await CustomClient4.getChannelsByIds(channelIds);
        } catch (error) {
            forceLogoutIfNecessary(error, dispatch);
            dispatch(batchActions([
                 {type: ChannelTypes.CHANNELS_FAILURE, error},
                  logError(error)(dispatch)
            ]), getState);
            return null;
        }
        
        dispatch(batchActions([
                 {type: ChannelTypes.RECEIVED_CHANNELS,data: channels}
        ]), getState);
        
        return channels;
    };
}

export async function getChannelsForXTeamPosts(posts, dispatch, getState) {
    if (!posts) {
        return Promise.resolve();
    }
    
    const channels = new Map();
    const AllChannels = ChannelStore.getXTeamChannels();
    AllChannels.forEach(function(channel) {
        if (!channels.has(channel.id)) {
            channels.set(channel.id, channel);
        }
    });
    
    const channelIdsToLoad = new Set();
    Object.values(posts).forEach((post) => {
        const channelId = post.channel_id;
        if(!channels.has(channelId)){
            channelIdsToLoad.add(channelId);   
        }
    });

    const promises = [];
    if (channelIdsToLoad.size > 0) {
        promises.push(getChannelsByIds(Array.from(channelIdsToLoad))(dispatch, getState));
    }
    return Promise.all(promises);
}

export function addMembersToChannel(channelId, userIds) {
    return async (dispatch, getState) => {
        dispatch({type: ChannelTypes.ADD_CHANNEL_MEMBER_REQUEST}, getState);

        let members;
        try {
            members = await CustomClient4.addMembersToChannel(channelId, userIds);
        } catch (error) {
            forceLogoutIfNecessary(error, dispatch);
            dispatch(batchActions([
                {type: ChannelTypes.ADD_CHANNEL_MEMBER_FAILURE, error},
                logError(error)(dispatch)
            ]), getState);
            return null;
        }

        const actions = [];
        members.forEach((m) => {
            actions.push({
                type: UserTypes.RECEIVED_PROFILE_IN_CHANNEL,
                data: {user_id: m.user_id},
                id: channelId
            });
        } );

        actions.push({
            type: ChannelTypes.RECEIVED_CHANNEL_MEMBERS,
            data: members
        });

        actions.push({
            type: ChannelTypes.ADD_CHANNEL_MEMBER_SUCCESS,
            data: channelId
        });


        dispatch(batchActions(actions, 'ADD_CHANNEL_MEMBER.BATCH'), getState);

        return members;
    };
}

export function addAllMembersToChannel(channelId) {
    return async (dispatch, getState) => {
        dispatch({type: ChannelTypes.ADD_CHANNEL_MEMBER_REQUEST}, getState);

        let members;
        try {
            members = await CustomClient4.addAllMembersToChannel(channelId);
        } catch (error) {
            forceLogoutIfNecessary(error, dispatch);
            dispatch(batchActions([
                {type: ChannelTypes.ADD_CHANNEL_MEMBER_FAILURE, error},
                logError(error)(dispatch)
            ]), getState);
            return null;
        }

        const actions = [];
        members.forEach((m) => {
            actions.push({
                type: UserTypes.RECEIVED_PROFILE_IN_CHANNEL,
                data: {user_id: m.user_id},
                id: channelId
            });
        } );

        actions.push({
            type: ChannelTypes.RECEIVED_CHANNEL_MEMBERS,
            data: members
        });

        actions.push({
            type: ChannelTypes.ADD_CHANNEL_MEMBER_SUCCESS,
            data: channelId
        });


        dispatch(batchActions(actions, 'ADD_CHANNEL_MEMBER.BATCH'), getState);

        return members;
    };
}

export function addGuestsToChannel(channelId, userIds) {
    return async (dispatch, getState) => {
        dispatch({type: ChannelTypes.ADD_CHANNEL_MEMBER_REQUEST}, getState);

        let members;
        try {
            members = await CustomClient4.addGuestsToChannel(channelId, userIds);
        } catch (error) {
            forceLogoutIfNecessary(error, dispatch);
            dispatch(batchActions([
                {type: ChannelTypes.ADD_CHANNEL_MEMBER_FAILURE, error},
                logError(error)(dispatch)
            ]), getState);
            return null;
        }

        const actions = [];
        members.forEach((m) => {
            actions.push({
                type: UserTypes.RECEIVED_PROFILE_IN_CHANNEL,
                data: {user_id: m.user_id},
                id: channelId
            });
        } );

        actions.push({
            type: ChannelTypes.RECEIVED_CHANNEL_MEMBERS,
            data: members
        });

        actions.push({
            type: ChannelTypes.ADD_CHANNEL_MEMBER_SUCCESS,
            data: channelId
        });


        dispatch(batchActions(actions, 'ADD_CHANNEL_MEMBER.BATCH'), getState);

        return members;
    };
}

export function addAllGuestsToChannel(channelId) {
    return async (dispatch, getState) => {
        dispatch({type: ChannelTypes.ADD_CHANNEL_MEMBER_REQUEST}, getState);

        let members;
        try {
            members = await CustomClient4.addAllGuestsToChannel(channelId);
        } catch (error) {
            forceLogoutIfNecessary(error, dispatch);
            dispatch(batchActions([
                {type: ChannelTypes.ADD_CHANNEL_MEMBER_FAILURE, error},
                logError(error)(dispatch)
            ]), getState);
            return null;
        }

        const actions = [];
        members.forEach((m) => {
            actions.push({
                type: UserTypes.RECEIVED_PROFILE_IN_CHANNEL,
                data: {user_id: m.user_id},
                id: channelId
            });
        } );

        actions.push({
            type: ChannelTypes.RECEIVED_CHANNEL_MEMBERS,
            data: members
        });

        actions.push({
            type: ChannelTypes.ADD_CHANNEL_MEMBER_SUCCESS,
            data: channelId
        });


        dispatch(batchActions(actions, 'ADD_CHANNEL_MEMBER.BATCH'), getState);

        return members;
    };
}

export function uploadChannelImage(channelId, imageData) {
    return async (dispatch, getState) => {

        dispatch({type: ChannelTypes.UPDATE_CHANNEL_REQUEST}, getState);

        try {
            await CustomClient4.uploadChannelImage(channelId, imageData);
        } catch (error) {
            dispatch({type: ChannelTypes.UPDATE_CHANNEL_FAILURE, error}, getState);
            return null;
        }

        dispatch({type: ChannelTypes.UPDATE_CHANNEL_SUCCESS}, getState);

        return true;
    };
}

export function uploadChannelBackground(channelId, imageData) {
    return async (dispatch, getState) => {

        dispatch({type: ChannelTypes.UPDATE_CHANNEL_REQUEST}, getState);

        try {
            await CustomClient4.uploadChannelBackgroundImage(channelId, imageData);
        } catch (error) {
            dispatch({type: ChannelTypes.UPDATE_CHANNEL_FAILURE, error}, getState);
            return null;
        }

        dispatch({type: ChannelTypes.UPDATE_CHANNEL_SUCCESS}, getState);

        return true;
    };
}

export function createChannelWithImages(channel, userId) {

    const request = Object.assign({}, channel);
    delete request.file;
    delete request.backgroundFile;
    const image = channel.file;
    const background = channel.backgroundFile;

    return async (dispatch, getState) => {
        dispatch(batchActions([
            {
                type: ChannelTypes.CREATE_CHANNEL_REQUEST
            },
            {
                type: ChannelTypes.CHANNEL_MEMBERS_REQUEST
            }
        ]), getState);

        let created;
        try {
            created = await CustomClient4.createChannelWithImages(request, image, background);
        } catch (error) {
            forceLogoutIfNecessary(error, dispatch);
            dispatch(batchActions([
                {
                    type: ChannelTypes.CREATE_CHANNEL_FAILURE,
                    error
                },
                {
                    type: ChannelTypes.CHANNEL_MEMBERS_FAILURE,
                    error
                },
                logError(error)(dispatch)
            ]), getState);
            return null;
        }

        const member = {
            channel_id: created.id,
            user_id: userId,
            roles: `${General.CHANNEL_USER_ROLE} ${General.CHANNEL_ADMIN_ROLE}`,
            last_viewed_at: 0,
            msg_count: 0,
            mention_count: 0,
            notify_props: {desktop: 'default', mark_unread: 'all'},
            last_update_at: created.create_at
        };

        const actions = [];
        const {channels, myMembers} = getState().entities.channels;

        if (!channels[created.id]) {
            actions.push({type: ChannelTypes.RECEIVED_CHANNEL, data: created});
        }

        if (!myMembers[created.id]) {
            actions.push({type: ChannelTypes.RECEIVED_MY_CHANNEL_MEMBER, data: member});
        }

        dispatch(batchActions([
            ...actions,
            {
                type: ChannelTypes.CREATE_CHANNEL_SUCCESS
            },
            {
                type: ChannelTypes.CHANNEL_MEMBERS_SUCCESS
            }
        ]), getState);

        return created;
    };
}

export default {
    updateSelfDestructTimer,
    batchUpdateSelfDestructTimer,
    getMyAllChannels,
    getChannelsByIds,
    addMembersToChannel,
    addAllMembersToChannel
};



// WEBPACK FOOTER //
// ./custom-redux/actions/channels.jsx